import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  nothing: defineAsyncComponent(() => import("/vercel/path0/layouts/nothing.vue").then(m => m.default || m))
}